export const tierLists = [
    [
        "Chihuahuan Raven",
        "Common Raven",
        "Franklin's Gull",
        "Killdeer",
        "Bonelli's Eagle",
        "Eastern Imperial Eagle",
    ],
    [
        "Abbot's Booby",
        "Atlantic Puffin",
        "Audouin's Gull",
        "Barn Swallow",
        "Baya Weaver",
        "Black-Headed Gull",
        "Blue Rock-Thrush",
        "Brambling",
        "Chipping Sparrow",
        "Common Chiffchaff",
        "Common Yellowthroat",
        "Eurasian Coot",
        "Galah",
        "Gray Catbird",
        "Great Indian Bustard",
        "Maned Duck",
        "Mourning Dove",
        "Mute Swan",
        "Noisy Miner",
        "Northern Mockingbird",
        "Pied Billed Grebe",
        "Purple Martin",
        "Red Avadavat",
        "Rose-Ringed Parakeet",
        "Rosy Starling",
        "Ruddy Duck",
        "Ruff",
        "Scaley-Breasted Munia",
        "Snow Bunting",
        "Spangled Drongo",
        "Spotted Dove",
        "White Stork",
        "White-Throated Dipper",
    ],
    [
        "Anna's Hummingbird",
        "American Crow",
        "American Redstart",
        "American Robin",
        "American Woodcock",
        "Asian Koel",
        "Australian Ibis",
        "Australian Reed Warbler",
        "Azure Tit",
        "Baird's Sparrow",
        "Bald Eagle",
        "Baltimore Oriole",
        "Bell's Vireo",
        "Black-Chinned Hummingbird",
        "Black-Crowned Night Heron",
        "Black-Napped Oriole",
        "Black Noddy",
        "Black Redstart",
        "Black-Tailed Godwit",
        "Black Tern",
        "Black-Throated Diver",
        "Blue-Gray Gnatcatcher",
        "Bluethroat",
        "Blue-Winged Warbler",
        "Bushtit",
        "Carolina Chickadee",
        "Carrion Crow",
        "Cassin's Finch",
        "Cassin's Sparrow",
        "Cerulean Warbler",
        "Clark's Grebe",
        "Common Chaffinch",
        "Common Cuckoo",
        "Common Grackle",
        "Common Iora",
        "Common Myna",
        "Common Nightingale",
        "Desert Wheatear",
        "Eastern Phoebe",
        "Eurasian Nutcracker",
        "Eurasian Sparrowhawk",
        "European Goldfinch",
        "Fire-Fronted Serin",
        "Fish Crow",
        "Forster's Tern",
        "Golden Eagle",
        "Golden Headed Cisticola",
        "Golden Pheasant",
        "Graceful Prina",
        "Grandala",
        "Grasshopper Sparrow",
        "Great Blue Heron",
        "Great Crested Grebe",
        "Great Egret",
        "Great Hornbill",
        "Great Horned Owl",
        "Green Pheasant",
        "Grey Teal",
        "Grey Warbler",
        "Griffon Vulture",
        "Hooded Warbler",
        "House Crow",
        "House Finch",
        "Himalayan Monal",
        "Ibisbill",
        "Indian Peafowl",
        "Indigo Bunting",
        "Kakapo",
        "Large-Billed Crow",
        "Laughing Kookaburra",
        "Lesser Frigatebird",
        "Lesser Whitethroat",
        "Little Ringed Plover",
        "Magpie Lark",
        "Mallard",
        "Mandarin Duck",
        "Many Colored Fruit Dove",
        "Masked Lapwing",
        "Moltoni's Warbler",
        "Mountain Chickadee",
        "North Island Brown Kiwi",
        "Northern Flicker",
        "Northern Goshawk",
        "Oriental-Bay Owl",
        "Osprey",
        "Painted Whitestart",
        "Peaceful Dove",
        "Pheasant Coucal",
        "Pileated Woodpecker",
        "Prothonotary Warbler",
        "Red-Breasted Merganser",
        "Red-Breasted Nuthatch",
        "Red Junglefowl",
        "Red Knot",
        "Red Legged Partridge",
        "Red Winged Black Bird",
        "Rhinoceros Auklet",
        "Rook",
        "Roseate Spoonbill",
        "Ruby-Throated Hummingbird",
        "Ruddy Shelduck",
        "Rufous Owl",
        "Savi's Warbler",
        "Scaled Quail",
        "Scissor-Tailed Flycatcher",
        "Small Minivet",
        "Smew",
        "Spotted Owl",
        "Spotted Sandpiper",
        "Sri Lanka Blue Magpie",
        "Stubble Quail",
        "Trumpeter Finch",
        "Trumpeter Swan",
        "Twite",
        "Violet Cuckoo",
        "White-Backed Woodpecker",
        "White-Breasted Nuthatch",
        "White-Faced Ibis",
        "White-Headed Duck",
        "White-Throated Swift",
        "White Wagtail",
        "Whooping Crane",
        "Wild Turkey",
        "Willow Tit",
        "Wilson's Snipe",
        "Wood Duck",
        "Wood Stork",
        "Wrybill",
        "Yellowhammer",
    ],
    [
        "American Avocet",
        "American Bittern",
        "American Coot",
        "Ash Throated Flycatcher",
        "Asian Emerald Dove",
        "Australian Magpie",
        "Australian Raven",
        "Barn Swallow",
        "Barrow's Goldeneye",
        "Belted Kingfisher",
        "Black Drongo",
        "Black Swan",
        "Blyth's Hornbill",
        "Bobolink",
        "Brewer's Blackbird",
        "Broad Winged Hawk",
        "Bronzed Cowbird",
        "Brown-Headed Cowbird",
        "Budgerigar",
        "Bullfinch",
        "California Quail",
        "Canada Goose",
        "Carolina Wren",
        "Cedar Waxwing",
        "Chestnut Collared Longspur",
        "Coal Tit",
        "Cockatiel",
        "Common Buzzard",
        "Common Kingfisher",
        "Common Moorhen",
        "Common Starling",
        "Common Swift",
        "Coppersmith Barbet",
        "Count Raggi's Bird of Paradise",
        "Crested Ibis",
        "Crimson Chat",
        "Dark-Eyed Junco",
        "Desert Finch",
        "Downy Woodpecker",
        "Dunnock",
        "Eastern Bluebird",
        "Eastern Screech Owl",
        "Eurasian Collared-Dove",
        "Eurasian Golden Oriole",
        "Eurasian Eagle-Owl",
        "Eurasian Hobby",
        "Eurasian Hoopoe",
        "Eurasian Kestrel",
        "Eurasian Magpie",
        "Eurasian Marsh-Harrier",
        "Eurasian Nuthatch",
        "European Robin",
        "Gould's Finch",
        "Gray Wagtail",
        "Great Spotted Woodpecker",
        "Great Tit",
        "Greater Adjutant",
        "Greater Prairie-Chicken",
        "Greater Roadrunner",
        "Green Bee-Eater",
        "Green Heron",
        "Grey-Headed Mannikin",
        "Grey Heron",
        "Greylag Goose",
        "Hermit Thrush",
        "Hooded Crow",
        "Hooded Merganser",
        "House Sparrow",
        "House Wren",
        "Inca Dove",
        "Juniper Titmouse",
        "Kea",
        "King Rail",
        "Lazuli Bunting",
        "Lewin's Honeyeater",
        "Little Egret",
        "Little Grebe",
        "Little Penguin",
        "Little Pied Cormorant",
        "Long Tailed Tit",
        "Malleefowl",
        "Mississippi Kite",
        "Mountain Bluebird",
        "New Holland Honeyeater",
        "Northern Bobwhite",
        "Northern Cardinal",
        "Northern Shoveler",
        "Olive-Backed Sunbird",
        "Orange Footed Scrubfowl",
        "Oriental Magpie-Robin",
        "Painted Bunting",
        "Philippine Eagle",
        "Plains Wanderer",
        "Plumbeous Redstart",
        "Princess Stephanie's Astrapia",
        "Purple Gallinule",
        "Red Backed Fairywren",
        "Red-Cockaded Woodpecker",
        "Red-Crowned Crane",
        "Red Eyed Vireo",
        "Red Headed Woodpecker",
        "Red-Wattled Lapwing",
        "Red-Winged Parrot",
        "Regent Bowerbird",
        "Ring-Billed Gull",
        "Rock Pigeon",
        "Rose-Breasted Grosbeak",
        "Ruby Crowned Kinglet",
        "Sacred Kingfisher",
        "Sandhill Crane",
        "Sarus Crane",
        "Savannah Sparrow",
        "Say's Phoebe",
        "Short Toed Treecreeper",
        "Silvereye",
        "Snowy Egret",
        "Southern Cassowary",
        "Spotted Towhee",
        "Splendid Fairywren",
        "Sprague's Pipit",
        "Tawny Frogmouth",
        "Tree Swallow",
        "Tufted Titmouse",
        "Verditer Flycatcher",
        "Violet-Green Swallow",
        "Wedge Tailed Eagle",
        "Western Meadowlark",
        "Western Tanager",
        "White Bellied Sea Eagle",
        "White Breasted Woodswallow",
        "White-Crested Laughingthrush",
        "White-Throated Kingfisher",
        "Willet",
        "Wilson's Storm Petrel",
        "Yellow-Billed Cuckoo",
        "Yellow-Headed Black Bird",
    ],
    [
        "Acorn Woodpecker",
        "Anhinga",
        "American Goldfinch",
        "American Kestrel",
        "American Oystercatcher",
        "American White Pelican",
        "Australasian Pipit",
        "Australian Owlet Nightjar",
        "Australian Shelduck",
        "Australian Shoveler",
        "Australian Zebra Finch",
        "Barn Owl",
        "Barred Owl",
        "Bearded Reedling",
        "Bewick's Wren",
        "Black-Bellied Whistling Duck",
        "Black Billed Magpie",
        "Black-Necked Stilt",
        "Black Shouldered Kite",
        "Black Skimmer",
        "Black Stork",
        "Black Vulture",
        "Black Woodpecker",
        "Blue Grosbeak",
        "Blue Jay",
        "Brahminy Kite",
        "Brant",
        "Brolga",
        "Brown Falcon",
        "Brown Pelican",
        "Brown Shrike",
        "Burrowing Owl",
        "California Condor",
        "Canvasback",
        "Cetti's Warbler",
        "Chimney Swift",
        "Clark's Nutcracker",
        "Common Blackbird",
        "Common Goldeneye",
        "Common Green Magpie",
        "Common Little Bittern",
        "Common Loon",
        "Common Merganser",
        "Common Nighthawk",
        "Common Sandpiper",
        "Common Tailorbird",
        "Common Teal",
        "Cooper's Hawk",
        "Corsican Nuthatch",
        "Crested Lark",
        "Crested Pigeon",
        "Dickcissel",
        "Double Crested Cormorant",
        "Eastern Kingbird",
        "Eastern Rosella",
        "Eastern Whipbird",
        "Elenora's Falcon",
        "Emu",
        "Eurasian Green Woodpecker",
        "Eurasian Jay",
        "Eurasian Treecreeper",
        "Eurasian Tree Sparrow",
        "European Bee Eater",
        "European Honey Buzzard",
        "European Roller",
        "European Turtle Dove",
        "Ferruginous Hawk",
        "Forest Owlet",
        "Goldcrest",
        "Great Cormorant",
        "Great Crested Flycatcher",
        "Greater Flamingo",
        "Green Pygmy Goose",
        "Grey Butcherbird",
        "Grey Shrike-Thrush",
        "Hawfinch",
        "Horned Lark",
        "Horsfield's Bronze-Cuckoo",
        "Horsfield's Bushlark",
        "Indian Vulture",
        "Kelp Gull",
        "Kereru",
        "Korimako",
        "Lincoln's Sparrow",
        "Little Bustard",
        "Little Owl",
        "Loggerhead Shrike",
        "Major Mitchell's Cockatoo",
        "Mistletoebird",
        "Montagu's Harrier",
        "Musk Duck",
        "Northern Gannet",
        "Northern Harrier",
        "Pacific Black Duck",
        "Parrot Crossbill",
        "Peregrine Falcon",
        "Pesquet's Parrot",
        "Pine Siskin",
        "Pink Eared Duck",
        "Pukeko",
        "Purple Heron",
        "Pygmy Nuthatch",
        "Rainbow Lorikeet",
        "Red-Backed Shrike",
        "Red-Bellied Woodpecker",
        "Red Capped Robin",
        "Red Crossbill",
        "Red Kite",
        "Red-Necked Avocet",
        "Red-Shouldered Hawk",
        "Red-Tailed Hawk",
        "Red-Vented Bulbul",
        "Red Wattlebird",
        "Royal Spoonbill",
        "Rufous Banded Honeyeater",
        "Rufous Night Heron",
        "Satyr Tragopan",
        "Snowy Owl",
        "Song Sparrow",
        "South Island Robin",
        "Spoon-Billed Sandpiper",
        "Spotless Crake",
        "Squacco Heron",
        "Sri Lanka Frogmouth",
        "Stellar's Jay",
        "Stork-Billed Flycatcher",
        "Sulphur-Crested Cockatoo",
        "Superb Lyrebird",
        "Swainson's Hawk",
        "Thekla's Lark",
        "Tui",
        "Turkey Vulture",
        "Vaux's Swift",
        "Welcome Swallow",
        "White-Browed Tit-Warbler",
        "White-Crowned Sparrow",
        "White Faced Heron",
        "Willie Wagtail",
        "Yellow-Bellied Sapsucker",
        "Yellow Bittern",
        "Yellow Breasted Chat",
        "Yellow-Rumped Warbler",
        "Zebra Dove",
    ]
]